import {   FETCH_ACTIVE_SEASONS, SAVE_SEASON_DATES, TRIGGER_SEASON,RESET_DATES_SETTINGS } from '../../actions'
import { arrayToObject } from '../../../utils/helperfunctions/arraytoobject'
  
    function getSeasonDates(seasons){
        const seasonDates = []
    
        seasons.map(function(season) {
          const s = {
               id: season.id,
               description: season.description,
               isCurrent:season.isCurrent,
               isSeasonSet:season.isSeasonSet,
               year: season.year,
               registrationOpensOn:season.registrationOpensOn,
               firstSemesterStartDate:season.firstSemesterStartDate,
               rankingStartDate:season.rankingStartDate,
               firstSemesterExceptionExclusionDate:season.firstSemesterExceptionExclusionDate,
               secondSemesterStartDate:season.secondSemesterStartDate,
               secondSemesterExceptionExclusionDate:season.secondSemesterExceptionExclusionDate,
               rankingEndDate:season.rankingEndDate,
               rollOverDate:season.rollOverDate
          }
          seasonDates.push(s)
        })
    
        return seasonDates
    }

    function getSingleSeasonDates(season){
       
          const s = {
               id: season.id,
               description: season.description,
               isCurrent:season.isCurrent,
               isSeasonSet:season.isSeasonSet,
               year: season.year,
               registrationOpensOn:season.registrationOpensOn,
               firstSemesterStartDate:season.firstSemesterStartDate,
               rankingStartDate:season.rankingStartDate,
               firstSemesterExceptionExclusionDate:season.firstSemesterExceptionExclusionDate,
               secondSemesterStartDate:season.secondSemesterStartDate,
               secondSemesterExceptionExclusionDate:season.secondSemesterExceptionExclusionDate,
               rankingEndDate:season.rankingEndDate,
               rollOverDate:season.rollOverDate
          }
      
        return s
    }
    
   export default function seasondates(state,action) {
        const {  payload } = action
        
        switch(action.type) {
          case FETCH_ACTIVE_SEASONS:{
            
            const { data } = payload

            if(data) {
            
                const defaultId = payload.data[0].id.toString()
                const seasonDates = getSeasonDates(data)
            
                const dates = arrayToObject(seasonDates,'id')
            
                return Object.assign({},state,{
                values: {
                    seasondates:dates,
                    settingsseason:defaultId,
                    initialstate:dates,
                    datesreset:false
                },
                fields: {
                    seasondates:dates,
                    settingsseason:defaultId,
                    initialstate:dates,
                    datesreset:false
                }
                })
            }
            else {
                return state
            }
          }
          case SAVE_SEASON_DATES: {
           
           const datasaved  = true 
           const savingdata = false
           const isSettingSeason = false

           return  { ...state, 
              values: {
                        ...state.values ,
                        savingdata,
                        datasaved,
                        isSettingSeason,
                        initialstate:state.values.seasondates,
                        datesreset:false         
                      },
              fields: {
                        ...state.fields,
                        savingdata,
                        datasaved,
                        isSettingSeason,
                        initialstate:state.values.seasondates,
                        datesreset:false  
                      }
            }
          
          }
          case TRIGGER_SEASON: {
            const seasontriggered  = true 
            const isSettingSeason = false
            
            const season  = getSingleSeasonDates(payload.data)
            const seasonId = season.id
            const { seasondates } = state.values
            seasondates[seasonId] = season
           
            return  { ...state, 
               values: {
                         ...state.values ,
                         seasontriggered,
                         isSettingSeason ,
                         seasondates: seasondates      
                       },
               fields: {
                         ...state.fields,
                         seasontriggered,
                         isSettingSeason,
                         seasondates:seasondates
                       }
             }
           
          }
          case RESET_DATES_SETTINGS:{
             
            const { initialstate } = state.values
          
            return  { ...state, 
                values: {
                         ...state.values,
                         seasondates:initialstate,
                         datesreset:true,
                      //   datasaved:true
                       },
                fields: {
                         ...state.fields,
                         seasondates:initialstate,
                         datesreset:true,
                       //  datasaved:true
                       }
             }
        }
          default: return state
        }
      } 


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasondates.js